import axios from "axios";
import schedules from "../../models/horarios/schedules";
import segments from "../../models/horarios/segments";
import segmentsAll from "../../models/horarios/segmentsAll";
import elements from "../../models/horarios/elements";
import elementsAll from "../../models/horarios/elementsAll";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getSchedules() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/horarios`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return schedules.fromJson(item);
        });
      });
  }

  getSegments(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const scheduleId = data;
    return axios
      .get(`${url}/horsegm/${scheduleId}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return segments.fromJson(item);
        });
      });
  }

  getSegmentsAll(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const scheduleId = data;
    return axios
      .get(`${url}/segmentos/all`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return segmentsAll.fromJson(item);
        });
      });
  }

  editSequence(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      numSecuencia: Number(data.sequence),
    };
    return axios.patch(
      `${url}/horsegm/${data.schedule}&${data.segmId}&${data.numberSequenceOld}`,
      payload,
      {
        headers,
      },
    );
  }
  getElements(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const id = data;
    return axios
      .get(`${url}/segmelem/eleminfo/${id}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return elements.fromJson(item);
        });
      });
  }
  getElementsAll() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/elementos/all`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return elementsAll.fromJson(item);
        });
      });
  }
  reuseElement(item) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      segmId: item.segmentId,
      elemId: item.id,
    };

    return axios.post(`${url}/segmelem`, payload, { headers });
  }
  newSchedule(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.name,
    };
    return axios.post(`${url}/horarios`, payload, { headers });
  }
  newScheduleAsistent(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.post(`${url}/horarios/all`, data, { headers });
  }

  reuseSegment(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      horarioId: data.schedule,
      segmId: data.segment,
      numSecuencia: data.sequence,
    };

    return axios.post(`${url}/horsegms`, payload, { headers });
  }

  newSegment(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.name,
      dias: parseInt(data.days, 10),
      desplJornada: data.desplJor,
      tipoJornada: parseInt(data.jor, 10),
      horarioId: data.schedule,
      numSecuencia: parseInt(data.sequence, 10),
    };

    return axios.post(`${url}/segmentos`, payload, { headers });
  }
  newElement(item) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: item.element,
      desde: item.from,
      hasta: item.to,
      tolEnt: item.entry,
      tolSal: item.exit,
      conceptoId: item.concept,
      mts: item.mts,
      fracRed: item.roundingFraction,
      porcen: item.porcentage,
      laboral: item.labor,
      aplNoFeriados: item.noHolidays,
      aplFeriados: item.holidays,
      segmId: item.segid,
    };

    return axios.post(`${url}/elementos`, payload, { headers });
  }
  deleteSchedule(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/horario/${id}`, { headers });
  }
  deleteSegment(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/segmentos/${id}`, { headers });
  }
  deleteSegmentRelation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/horsegm/${data.scheduleId}&${data.segmId}&${data.numberSequence}`,
      { headers },
    );
  }
  editSegment(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const id = data.segmId;

    let payload = {
      nombre: data.name,
      dias: parseInt(data.days, 10),
      desplJornada: data.desplJor,
      tipoJornada: parseInt(data.jor, 10),
    };

    return axios.patch(`${url}/segmentos/${id}`, payload, { headers });
  }
  editSchedule(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const id = data.id;

    let payload = {
      nombre: data.name,
    };

    return axios
      .patch(`${url}/horarios/${id}`, payload, { headers })
      .then(() => {});
  }
  copySchedule(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      horarioIdToCopy: data.id,
      nonbreHorario: data.name,
    };

    return axios.post(`${url}/horarios/copiar`, payload, { headers });
  }
  editElement(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const id = data.id;
    let payload = {
      nombre: data.element,
      desde: data.from,
      hasta: data.to,
      tolEnt: data.entry,
      tolSal: data.exit,
      conceptoId: data.concept,
      mts: data.mts,
      fracRed: data.roundingFraction,
      porcen: data.porcentage,
      laboral: data.labor,
      aplNoFeriados: data.noHolidays,
      aplFeriados: data.holidays,
    };

    return axios
      .patch(`${url}/elementos/${id}`, payload, { headers })
      .then(() => {});
  }
  deleteElement(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/elementos/${id}`, { headers });
  }
  deleteElementRelation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/segmelem/${data.segmentId}&${data.elemId}`, {
      headers,
    });
  }
}
export default service;
